import { Component, OnInit } from '@angular/core';
import { AsyncPipe } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';

import { isNil } from 'lodash';

import { YesNoEnum } from '@shared/model/yes-no.model';
import { BaseFormControlDirective } from '../base-form-control.directive';
import { YesNoValueCheckboxDirective } from './directives/yes-no-value-checkbox.directive';
import { ControlWrapperComponent } from '../control-wrapper/control-wrapper.component';
import { ControlHasRequiredPipe } from '../pipes/control-has-required.pipe';

@Component({
  standalone: true,
  selector: 'app-checkbox',
  templateUrl: 'checkbox.component.html',
  styleUrls: ['checkbox.component.scss'],
  imports: [ReactiveFormsModule, YesNoValueCheckboxDirective, ControlWrapperComponent, ControlHasRequiredPipe, AsyncPipe],
})
export class CheckboxComponent extends BaseFormControlDirective implements OnInit {
  ngOnInit(): void {
    super.ngOnInit();
    this.castDefaultValue();
  }

  private castDefaultValue(): void {
    isNil(this.control.value) && this.control.setValue(YesNoEnum.N, { emitEvent: false, onlySelf: true });
  }
}
